module.exports = "/build/web/svg/calendar-clock-white.6e0eae1cf9d7279b1afe3b28a25d77fd.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/calendar-clock-white.svg
// module id = 148
// module chunks = 24